var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_34752",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.890625,
    y: 0.5,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_34752)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.88802,
    cy: 7.4974,
    r: 5.83333,
    fill: "#04B54C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71823 8.60208L10.1599 5.16042C10.2668 5.05347 10.403 5 10.5682 5C10.7335 5 10.8696 5.05347 10.9766 5.16042C11.0835 5.26736 11.137 5.40347 11.137 5.56875C11.137 5.73403 11.0835 5.87014 10.9766 5.97708L7.12656 9.82708C7.0099 9.94375 6.87378 10.0021 6.71823 10.0021C6.56267 10.0021 6.42656 9.94375 6.3099 9.82708L4.79323 8.31042C4.68628 8.20347 4.63281 8.06736 4.63281 7.90208C4.63281 7.73681 4.68628 7.60069 4.79323 7.49375C4.90017 7.38681 5.03628 7.33333 5.20156 7.33333C5.36684 7.33333 5.50295 7.38681 5.6099 7.49375L6.71823 8.60208Z",
    fill: "#DDEFE5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/Green-check.5d72ae5355006e63bfcb26499c0f0f97.svg";
export { ForwardRef as ReactComponent };